import CodeRule from './Index.vue'

CodeRule.install = function(Vue) {
  Vue.component(CodeRule.name, CodeRule)
}

export { CodeRule }
